import moment from 'moment-timezone';
import {Timezone} from '../../components/trading-view-chart/charting-library/datafeed-api';

export const AVAILABLE_TIMEZONES: Timezone[] = [
    'America/New_York',
    'America/Los_Angeles',
    'America/Chicago',
    'America/Phoenix',
    'America/Toronto',
    'America/Vancouver',
    'America/Argentina/Buenos_Aires',
    'America/El_Salvador',
    'America/Sao_Paulo',
    'America/Bogota',
    'America/Caracas',
    'Europe/Moscow',
    'Europe/Athens',
    'Europe/Berlin',
    'Europe/London',
    'Europe/Madrid',
    'Europe/Paris',
    'Europe/Rome',
    'Europe/Warsaw',
    'Europe/Istanbul',
    'Europe/Zurich',
    'Australia/Sydney',
    'Australia/Brisbane',
    'Australia/Adelaide',
    'Australia/ACT',
    'Asia/Almaty',
    'Asia/Ashkhabad',
    'Asia/Tokyo',
    'Asia/Taipei',
    'Asia/Singapore',
    'Asia/Shanghai',
    'Asia/Seoul',
    'Asia/Tehran',
    'Asia/Dubai',
    'Asia/Kolkata',
    'Asia/Hong_Kong',
    'Asia/Bangkok',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'Pacific/Fakaofo',
    'Pacific/Honolulu',
    'America/Mexico_City',
    'Africa/Johannesburg',
    'Asia/Kathmandu',
    'US/Mountain',
    'Etc/UTC'
];

export const getTimeZoneNameForChart = (): Timezone => {
    const currentTimeStamp = moment().valueOf();
    const localTimeZoneName = moment.tz.guess(true);
    const isLocalTimeZoneAvailable: boolean = AVAILABLE_TIMEZONES.includes(localTimeZoneName as Timezone);
    const localTimeZoneOffset = moment.tz.zone(localTimeZoneName).utcOffset(currentTimeStamp);
    const foundTimeZone = !isLocalTimeZoneAvailable
        ? AVAILABLE_TIMEZONES
            .find(timeZone => moment.tz.zone(timeZone).utcOffset(currentTimeStamp) === localTimeZoneOffset)
        : null;

    return isLocalTimeZoneAvailable
        ? localTimeZoneName as Timezone
        : foundTimeZone
            ? foundTimeZone
            : 'Etc/UTC';
};
